import React from 'react';
import './Spinner.css';

const Spinner = () => {

  return (
    <div className="wrapAllPage" >
      <div className="Loader" >Loading...</div>
    </div>
  );
}
export default Spinner;